<template>
  <g>
    <circle cx="12" cy="12" r="9.1" :stroke="iconColor" stroke-width="1.8" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.006 10.7129C11.2587 11.5632 10.4083 12.531 10.6369 14.0239H12.725C12.5993 12.8744 13.2863 12.1141 13.9846 11.3412C14.6465 10.6086 15.3186 9.86472 15.3186 8.76737C15.3186 6.73461 13.8831 5.75 11.9256 5.75C10.5064 5.75 9.34825 6.40112 8.5 7.33809L9.82132 8.51327C10.3433 7.9892 10.9143 7.62394 11.632 7.62394C12.4803 7.62394 13.0186 8.13213 13.0186 8.92617C13.0186 9.56053 12.5385 10.1069 12.006 10.7129ZM10.1968 16.7277C10.1968 17.5853 10.833 18.2523 11.6812 18.2523C12.5458 18.2523 13.182 17.5853 13.182 16.7277C13.182 15.8701 12.5458 15.2031 11.6812 15.2031C10.833 15.2031 10.1968 15.8701 10.1968 16.7277Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      required: true
    }
  }
};
</script>
